import { useState, useEffect } from "react";
import Topheader from "../../../../Layout/header/header";
import "./notifications.css";
import Sidebar from "../sidebar/sidebar";
import { Box, Typography, Chip, TextField } from "@mui/material";
import APIManager from "../../../../Services/ApiManager/ApiManager";
import PopupDialog from "../../../../Components/PopupDialog";
import OemAdminLegalDocumentation from "../../../../Components/OEM-Admin-Components/OemAdminLegalDocumentation/OemAdminLegalDocumentation";
import { getConfig } from "../../../../config";

export default function Notifications() {
  const [dataFromChild, setDataFromChild] = useState("");
  const [oemEmailNotification, setOemEmailNotification] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const [componentName, setComponentName] = useState("");
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [headerMessage, setHeaderMessage] = useState("");
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim()) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (emailRegex.test(inputValue.trim())) {
        setOemEmailNotification([...oemEmailNotification, inputValue.trim()]);
        handleEmailAddressInSetting({
          emailRecipients: [...oemEmailNotification, inputValue.trim()],
        });
        setInputValue("");
      }
    }
  };

  function handleDataFromChild(data) {
    setDataFromChild(data);
  }
  const handleEmailAddressInSetting = (emailRecipientsParameters) => {
    APIManager.putNewEmailAddressForOemSettings(emailRecipientsParameters)
      .catch((error) => {
        setComponentName("appError");
        setErrorMessage(error.message);
        setHeaderMessage(
          error.message === "jwt expired" ? "401 Token Expired" : "Error"
        );
        setOpenErrorPopup(true);
      });
  };

  useEffect(() => {
    APIManager.getOemSettingsEmailNotification()
      .then((response) => {
        if (response === null || response === undefined) {
          setOemEmailNotification([]);
        }
        setOemEmailNotification(response);
      })
      .catch((error) => {
        if (error.message.includes("Unexpected end of JSON input")) {
          setOemEmailNotification([]);
        } else {
          setComponentName("appError");
          setErrorMessage(error.message);
          setHeaderMessage(
            error.message === "jwt expired" ? "401 Token Expired" : "Error"
          );
          setOpenErrorPopup(true);
        }
      });
  }, []);

  return (
    <>
      <Topheader />
      <Box
        sx={{
          marginTop: "3%",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "-webkit-box",
          }}
        >
          <Sidebar
            sendDataToParent={handleDataFromChild}
            page="notifications"
          />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Box
              className="notifications-main- section"
              sx={{ flexGrow: 1, marginLeft: "20px" }}
            >
              <Box
                justifyContent="space-between"
                alignItems="center"
                mb={2}
                width="89%"
              >
                <Typography
                  sx={{
                    fontSize: "24px",
                    marginTop: "33px",
                    fontWeight: "500",
                  }}
                >
                  {dataFromChild} - Notifications
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "24px",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                    borderTop: "1px solid #12141533",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "20px",
                      fontWeight: "500",
                      marginTop: "5px",
                    }}
                  >
                    Notification Settings
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    marginTop: "10px",
                    justifyContent: "flexStart",
                    flexDirection: "column",
                    marginLeft: "1px",
                    gap: "8px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: "500",
                    }}
                  >
                    New Apps Category And Notifications
                  </Typography>

                  <Typography sx={{ fontSize: "14px", color: "#717273" }}>
                    Under the "New Apps" category, newly published apps will be
                    highlighted with a{" "}
                    <span
                      style={{
                        margin: "4px",
                        backgroundColor: "#FFD505",
                        color: "#000000",
                        padding: "6px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      NEW
                    </span>{" "}
                    tag for 30 days
                  </Typography>
                </Box>
                <div className="notification-period-section">
                  <div
                    style={{
                      height: "60px",
                      borderBottom: "1px solid #12141533",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        marginLeft: "24px",
                      }}
                    >
                      {" "}
                      Modify the notification period to{" "}
                      <span
                        style={{
                          margin: "8px",
                          border: "1px solid #12141533",
                          padding: "4px 8px 4px 8px",
                        }}
                      >
                        {" "}
                        30{" "}
                      </span>{" "}
                      Days
                    </Typography>
                  </div>
                  <div
                    style={{
                      height: "70px",
                      borderBottom: "1px solid #12141533",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Typography
                      sx={{
                        marginLeft: "24px",
                      }}
                    >
                      Randomize Apps
                    </Typography>
                    <Typography
                      sx={{
                        marginLeft: "24px",
                        fontSize: "14px",
                        color: "#717273",
                      }}
                    >
                      Users will receive notification when a new app gets
                      available for their portfolio or when an app is published
                    </Typography>
                  </div>
                  <div
                    style={{
                      height: "max-content",
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "4px",
                    }}
                  >
                    <Typography
                      sx={{
                        marginLeft: "24px",
                        marginTop: "8px",
                      }}
                    >
                      Notifier email address for app notifications.
                    </Typography>
                    <Typography
                      sx={{
                        marginLeft: "24px",
                        fontSize: "14px",
                        color: "#717273",
                      }}
                    >
                      Users will receive notification when a new app gets
                      available for their portfolio or when an app is published
                    </Typography>
                    <TextField
                      sx={{
                        marginTop: "12px",
                        marginLeft: "24px",
                        maxWidth: "864px",
                        "@media (max-width: 1400px)": {
                          maxWidth: "756px",
                        },
                        "& .MuiOutlinedInput-root": {
                          height: "auto !important",
                          minHeight: "56px",
                          display: "flex",
                          flexWrap: "wrap",
                          alignItems: "flex-start",
                          padding: "8px",
                          gap: "8px",
                        },
                        "& .MuiInputBase-input": {
                          height: "24px !important",
                          padding: "0px 8px",
                        },
                        "& .MuiFormHelperText-root": {
                          display: "flex",
                          justifyContent: "flex-end",
                        },
                      }}
                      value={inputValue}
                      id="outlined-basic"
                      type="text"
                      variant="outlined"
                      onChange={handleInputChange}
                      onKeyDown={handleKeyDown}
                      slotProps={{
                        formHelperText: {
                          style: {
                            display: "flex",
                            justifyContent: "flex-end",
                            marginRight: "0px",
                          },
                        },
                        input: {
                          startAdornment: oemEmailNotification.map(
                            (email) => (
                              <Chip
                                key={email}
                                label={email}
                                size="small"
                                onDelete={() => null}
                                sx={{
                                  borderRadius: "2px",
                                  backgroundColor: "#F3F3F3",
                                  "& .MuiChip-deleteIcon": {
                                    color: "#757575",
                                  },
                                }}
                              />
                            )
                          ),
                        },
                      }}
                      multiline
                    />
                    <div className="emails-added-container">
                      <Typography sx={{ fontSize: "12px", color: "#0000008A" }}>
                        This notification applies only to the currently selected
                        portfolio.
                      </Typography>
                      <Typography sx={{ fontSize: "12px", color: "#0000008A" }}>
                        {oemEmailNotification.length} emails added
                      </Typography>
                    </div>
                  </div>
                </div>
              </Box>
            </Box>
            {getConfig().REACT_APP_PORTAL === "oem-admin" &&
              sessionStorage.getItem("idpLogin") === "true" && (
                <div className="legalDocumentationOemAdmin">
                  <OemAdminLegalDocumentation />
                </div>
              )}
          </div>
        </Box>
      </Box>

      <PopupDialog
        openErrorPopup={openErrorPopup}
        errorMessage={errorMessage}
        headerMessage={headerMessage}
        componentName={componentName}
        onClose={() => setOpenErrorPopup(false)}
      />
    </>
  );
}
